//使用钩子函数对路由进行权限跳转
import Vue from 'vue'
import router from '@/router'
import NProgress from 'nprogress'
import {getToken} from '@/utils/auth'
import {Message} from 'element-ui'
import store from './store'
// 路由黑名单，以下页面需要登录
const whiteList = ['/login', '/register']
router.beforeEach((to, from, next) => {
  const role = getToken()
  console.log(to)
  //如果已经登录
  if (role) {
    if (to.path === '/login') {
      next()
      NProgress.done()
    } else {
      store.dispatch('getShopInfo').then(() => {
        next()
      }).catch(err => {
        store.dispatch('LogOut').then(() => {
          Message.error(err)
          next({path: '/'})
        })
      })
    }
  } else {
    if (whiteList.indexOf(to.path) !== -1) {
      // 不在黑名单之内的直接进入
      next()
    } else {
      Vue.prototype.$message({
        message: '请先登录',
        center: true,
      })
      next(`/login?redirect=${to.fullPath}`) // 否则全部重定向到登录页
      NProgress.done()
    }
  }
})



// WEBPACK FOOTER //
// ./src/permission.js